import { Map } from "maplibre-gl";

export function addIcon(id: string, canvas: HTMLCanvasElement, map: Map) {
	const context = canvas.getContext('2d') as CanvasRenderingContext2D;
	const data = context.getImageData(
		0,
		0,
		canvas.width,
		canvas.height
	).data;

	if (!map.hasImage(id)) {
		map.addImage(id, {
			data: data,
			width: canvas.width,
			height: canvas.height
		},
			{ pixelRatio: 2 });
	}

}

export function getCircle(): HTMLCanvasElement {
	const circleWidth = 16 * 2;
	const size = circleWidth + 8; //shadow padding

	const canvas = document.createElement('canvas');
	canvas.width = size;
	canvas.height = size;
	const context = canvas.getContext('2d') as CanvasRenderingContext2D;


	context.clearRect(0, 0, size, size);
	// context.fillStyle = "#f00";
	// context.fillRect(0, 0, size, size)
	context.beginPath();
	context.arc(
		size / 2,
		size / 2,
		circleWidth / 2,
		0,
		Math.PI * 2
	);
	context.fillStyle = '#fff';
	context.shadowColor = "#000000cc";
	context.shadowOffsetX = 2;
	context.shadowOffsetY = 2;
	context.shadowBlur = 4;
	context.fill();
	return canvas;
}

export function getArrow(): HTMLCanvasElement {
	const size = 14 * 2;

	const canvas = document.createElement('canvas');
	canvas.width = size;
	canvas.height = size;
	const context = canvas.getContext('2d') as CanvasRenderingContext2D;


	context.clearRect(0, 0, size, size);
	// context.fillStyle = "#f00";
	// context.fillRect(0, 0, size, size)
	context.beginPath();
	context.moveTo(size / 2, 4);
	context.lineTo(size / 2, size - 4);
	context.moveTo(size / 2 + 7, 10);
	context.lineTo(size / 2, 4);
	context.lineTo(size / 2 - 7, 10);
	context.fillStyle = '#fff';
	// context.shadowColor = "#000000cc";
	// context.shadowOffsetX = 2;
	// context.shadowOffsetY = 2;
	// context.shadowBlur = 4;

	context.strokeStyle = "black";
	context.lineCap = "round";
	context.lineWidth = 4;
	context.stroke();
	return canvas;
}

export function getEmpty(): HTMLCanvasElement {
	const size = 14 * 2;

	const canvas = document.createElement('canvas');
	canvas.width = size;
	canvas.height = size;

	// const context = canvas.getContext('2d') as CanvasRenderingContext2D;
	// context.clearRect(0, 0, size, size);
	// context.fillStyle = "#f00";
	// context.fillRect(0, 0, size, size)
	return canvas;
}